/**
 * @generated SignedSource<<d5868550803b6bb103d61b4ee1ef0e65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type EventMemberControl = "HIDDEN" | "SELECTABLE" | "VISIBLE";
export type EventPrimaryChargeType = "PER_PERSON" | "PER_SIGN_UP";
import { FragmentRefs } from "relay-runtime";
export type EventDetailSignUpCard_event$data = {
  readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
  readonly clientEligibleSignUpWindows: ReadonlyArray<{
    readonly cancelDeadlineAt: string | null | undefined;
    readonly cancelDeadlineDaysAhead: number | null | undefined;
    readonly cancelDeadlineTime: string | null | undefined;
    readonly charges: {
      readonly edges: ReadonlyArray<{
        readonly memberControl: EventMemberControl;
        readonly node: {
          readonly chargeRuleSet: {
            readonly chargeRules: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly price: number;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly displayDescription: string | null | undefined;
            readonly displayName: string | null | undefined;
            readonly id: string;
          };
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly closeDaysAhead: number | null | undefined;
    readonly closeTime: string | null | undefined;
    readonly closesAt: string | null | undefined;
    readonly openTime: string | null | undefined;
    readonly opensAt: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly eventSeries: {
    readonly facility: {
      readonly club: {
        readonly slug: string;
      } | null | undefined;
      readonly id: string;
    };
    readonly name: string;
  };
  readonly id: string;
  readonly maxGuestCount: number;
  readonly maxMemberCount: number;
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly minGuestCount: number;
  readonly minMemberCount: number;
  readonly primaryChargeType: EventPrimaryChargeType | null | undefined;
  readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
  readonly signUps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly registrations: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly registrant: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly unknownGuestsAllowed: boolean | null | undefined;
  readonly " $fragmentType": "EventDetailSignUpCard_event";
};
export type EventDetailSignUpCard_event$key = {
  readonly " $data"?: EventDetailSignUpCard_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailSignUpCard_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailSignUpCard_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "accessStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "signUpStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryChargeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minMemberCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minGuestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unknownGuestsAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpConnection",
      "kind": "LinkedField",
      "name": "signUps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationConnection",
                  "kind": "LinkedField",
                  "name": "registrations",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventRegistrationEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "registrant",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "EventSignUpWindow",
      "kind": "LinkedField",
      "name": "clientEligibleSignUpWindows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closeDaysAhead",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closeTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closesAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "openTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "opensAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineDaysAhead",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSignUpWindowChargesConnection",
          "kind": "LinkedField",
          "name": "charges",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSignUpWindowChargesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberControl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventRegistrationChargeType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ChargeRuleSet",
                      "kind": "LinkedField",
                      "name": "chargeRuleSet",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayDescription",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ChargeRuleConnection",
                          "kind": "LinkedField",
                          "name": "chargeRules",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ChargeRuleEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ChargeRule",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "price",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "864314768510539647e98eec37d5232f";

export default node;
